<template>
    <div class="h-100">
        <b-container fluid>
            <h2 class="tw-mb-0 text-aegis-dk">
                Anopheles Data Entry
                <b-badge>{{collectionCode}}</b-badge>
            </h2>
            <p class="tw-italic tw-text-gray-700">
                Select a collection code and add Anopheline data
            </p>
        </b-container>

        <b-modal id="ento-summary" centered ok-only :hide-header="true" size="lg" title="Ento Summary">
            <EntoDataSummary :collection-code="collectionCode" v-if="collectionCode" />
        </b-modal>

        <b-container fluid>
            <b-row>
                <b-col>
                    <b-form-input
                        label="Collection Code"
                        placeholder="Collection Code / Household, Collection Date (YYYY-MM-DD)"
                        v-model="keyword"
                        size="lg"
                        @keypress.enter="search()"
                        @click:append="search()"
                    ></b-form-input>

                    <!-- <datalist id="cc-list">
                        <option
                            v-for="cCode in collectionCodes"
                            :key="cCode.id"
                        >
                            {{ cCode.collection_code }}
                        </option>
                    </datalist> -->
                </b-col>
                <b-col cols="auto">
                    <b-button @click="search()" block size="lg" variant="success">
                       Search Code
                    </b-button>
                </b-col>
                <b-col cols="auto" v-if="collectionCode">
                    <b-button v-b-modal.ento-summary block size="lg" variant="success">
                       <i class="fas fa-info"></i>
                    </b-button>
                </b-col>
            </b-row>
            <!-- <b-row>
                <b-col>
                    <br />
                </b-col>
            </b-row>
            <b-row>
                <b-col></b-col>
                <b-col cols="auto">
                    <b-form-datepicker
                        id="start_date"
                        v-model="formData.start_date"
                        placeholder="Start Date"
                        class="mb-2"
                        size="lg"
                    >
                    </b-form-datepicker>
                </b-col>
                <b-col cols="auto" v-if="formData.start_date">
                    <b-form-datepicker
                        id="end_date"
                        :min="formData.start_date"
                        v-model="formData.end_date"
                        placeholder="End Date"
                        class="mb-2"
                        size="lg"
                    >
                    </b-form-datepicker>
                </b-col>
                <b-col cols="auto">
                    <b-button
                        @click="filter()"
                        variant="success"
                        class="px-5"
                        size="lg"
                    >
                        Filter by Range
                    </b-button>
                </b-col>
            </b-row> -->
        </b-container>

        <hr />

        <b-container fluid>
            <b-row>
                <b-col></b-col>
                <b-col cols="auto">
                    <b-form-datepicker
                        id="start_date"
                        v-model="formData.start_date"
                        placeholder="Start Date"
                        class="mb-2"
                        size="lg"
                    >
                    </b-form-datepicker>
                </b-col>
                <b-col cols="auto" v-if="formData.start_date">
                    <b-form-datepicker
                        id="end_date"
                        :min="formData.start_date"
                        v-model="formData.end_date"
                        placeholder="End Date"
                        class="mb-2"
                        size="lg"
                    >
                    </b-form-datepicker>
                </b-col>
                <b-col cols="auto">
                    <b-button
                        @click="filter()"
                        variant="success"
                        class="px-5"
                        size="lg"
                        :disabled="!formData.end_date"
                    >
                        Search by Range
                    </b-button>
                </b-col>
                <b-col cols="auto">
                    <b-button
                        @click="download()"
                        variant="success"
                        class="px-5"
                        size="lg"
                        :disabled="!formData.end_date"
                    >
                        Download
                    </b-button>
                </b-col>
            </b-row>
        </b-container>
        <hr />

        <b-container fluid>
            <b-row>
                <b-col class="text-right">
                    <b-button
                        variant="success"
                        v-if="
                            selectedCollectionCode &&
                            (selectedCollectionCode.status == 'open' || selectedCollectionCode.status == 'draft')
                        "
                        @click="updateCollectionCodeStatus('locked')"
                        class="mx-2"
                    >
                        Lock Table
                    </b-button>
                    <b-button
                        variant="danger"
                        v-if="
                            selectedCollectionCode &&
                            selectedCollectionCode.status == 'locked'
                        "
                        @click="updateCollectionCodeStatus('editing')"
                        class="mx-2"
                    >
                        Request Edit
                    </b-button>
                    <!-- <b-button variant="danger" v-if="selectedCollectionCode && selectedCollectionCode.status == 'edit_requested'" @click="updateCollectionCodeStatus('editing')" class="mx-2">
            Allow Edit
          </b-button> -->
                    <b-button
                        variant="danger"
                        v-if="
                            (selectedCollectionCode &&
                                selectedCollectionCode.status == 'editing') ||
                            (selectedCollectionCode &&
                                selectedCollectionCode.status ==
                                    'changes_rejected')
                        "
                        @click="updateCollectionCodeStatus('review_required')"
                        class="mx-2"
                    >
                        Request Review
                    </b-button>
                    <b-button
                        variant="success"
                        v-if="
                            selectedCollectionCode &&
                            selectedCollectionCode.status == 'review_required'
                        "
                        @click="updateCollectionCodeStatus('locked')"
                        class="mx-2"
                    >
                        Re-Lock Table
                    </b-button>
                    <b-button
                        variant="danger"
                        v-if="
                            selectedCollectionCode &&
                            selectedCollectionCode.status == 'review_required'
                        "
                        @click="updateCollectionCodeStatus('changes_rejected')"
                        class="mx-2"
                    >
                        Reject Changes
                    </b-button>
                </b-col>
            </b-row>
            <b-row v-if="(selectedCollectionCode && selectedCollectionCode.id) || (startDate && endDate)">
                <b-col class="tw-p-1">
                    <b-tabs
                        v-model="tabIndex"
                        content-class="mt-4"
                        justified
                        lazy
                    >
                        <b-tab title="Anoph Individual" active>
                            <template v-slot:title>
                                <h4>Anoph Individual</h4>
                            </template>

                            <EntoDataHOT
                                :collectionCode="collectionCode"
                                :collectionCodeStatus="collectionCodeStatus"
                                :start-date="startDate"
                                :end-date="endDate"
                                templateId="ento_its2"
                            />
                        </b-tab>
                        <!-- <b-tab title="SpeciesID">
                            <template v-slot:title>
                                <h4>SpeciesID</h4>
                            </template>

                            <EntoDataHOT
                                :collectionCode="collectionCode"
                                :collectionCodeStatus="collectionCodeStatus"
                                templateId="pcr"
                            />
                        </b-tab>
                        <b-tab title="ELISA Result">
                            <template v-slot:title>
                                <h4>ELISA Result</h4>
                            </template>

                            <EntoDataHOT
                                :collectionCode="collectionCode"
                                :collectionCodeStatus="collectionCodeStatus"
                                templateId="kdr"
                            />
                        </b-tab> -->
                        <b-tab title="Males">
                            <template v-slot:title>
                                <h4>Males</h4>
                            </template>

                            <EntoDataHOT
                                :collectionCode="collectionCode"
                                :collectionCodeStatus="collectionCodeStatus"
                                :start-date="startDate"
                                :end-date="endDate"
                                templateId="males"
                            />
                        </b-tab>
                        <b-tab title="Culex">
                            <template v-slot:title>
                                <h4>Culex</h4>
                            </template>

                            <EntoDataHOT
                                :collectionCode="collectionCode"
                                :collectionCodeStatus="collectionCodeStatus"
                                :start-date="startDate"
                                :end-date="endDate"
                                templateId="culex"
                            />
                        </b-tab>
                        <b-tab title="Delete">
                            <template v-slot:title>
                                <h4>Delete</h4>
                            </template>

                            <EntoDataHOT
                                :collectionCode="collectionCode"
                                :collectionCodeStatus="collectionCodeStatus"
                                :start-date="startDate"
                                :end-date="endDate"
                                templateId="deleted"
                            />
                        </b-tab>

                        <!-- <b-tab title="Other Species" active>
              <EntoDataHOT v-if="tabIndex == 0" :collectionCode="collectionCode" templateId="other" />
            </b-tab>
            <b-tab title="Deleted">
              <EntoDataHOT v-if="tabIndex == 1" :collectionCode="collectionCode" templateId="deleted" />
            </b-tab> -->
                    </b-tabs>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<script>
import { HTTP } from "@/utilities/http-common";
import HandleErrors from "@/utilities/handle-errors";

import DashboardBaseTemplate from "@/layouts/DashboardBaseTemplate.vue";
import EntoDataHOT from "@/components/unitaid/ento-data/EntoDataHOT.vue";

import EntoDataSummary from "@/components/unitaid/ento-data/EntoDataSummary";

import { mapActions } from "vuex";
import * as _ from "lodash";

export default {
    components: {
        EntoDataHOT,
        EntoDataSummary
    },
    mixins: [DashboardBaseTemplate],
    data: function () {
        return {
            keyword: "",
            collectionCode: "",
            collectionCodeStatus: "draft",
            collectionCodes: [],
            selectedCollectionCode: null,
            tabIndex: 0,
            formData: {},
            startDate: '',
            endDate: ''
        };
    },
    created(){
        this.unpackUrlQueryParams(this.$route.query);
    },
    mounted() {
        const that = this;

        if(this.$route.query.tabIndex) {
            this.tabIndex = parseInt(this.$route.query.tabIndex);
        }
        // this.tabIndex = 0;

        // that.getEntoCollectionCodes()
        //     .then((response) => {
        //         _.each(response.data, function (item) {
        //             // if (item.status !== "draft") {
        //             //     that.collectionCodes.push(item);
        //             // }
        //             that.collectionCodes.push(item);
        //         });

        //         console.log('mounted.collectionCode: ', that.collectionCodes);

        //         if(that.$route.query.collectionCode) {
        //             that.keyword = that.$route.query.collectionCode;
        //         }

        //         that.search();
        //     })
        //     .catch((error) => {
        //         HandleErrors.HandleErrors(error);
        //     });
    },
    methods: {
        ...mapActions("websheet", ["getEntoCollectionCodes", "getEntoData"]),
        // search: function () {
        //     const that = this;

        //     that.startDate = '';
        //     that.endDate = '';

        //     if(!that.keyword) {
        //         return;
        //     }

        //     // that.selectedCollectionCode = _.find(that.collectionCodes, [
        //     //     "collection_code",
        //     //     that.keyword,
        //     // ]);

        //     that.selectedCollectionCode = _.find(that.collectionCodes, (o) => {
        //         let collection_code = _.startsWith(o.collection_code, that.keyword);
        //         let structure_id = _.startsWith(o.structure_id, that.keyword);
        //         let collection_date = _.startsWith(o.collection_date, that.keyword);

        //         return (collection_code || structure_id || collection_date);
        //     });

        //     console.log('search.selectedCollectionCode', JSON.stringify(that.selectedCollectionCode))

        //     if(!that.selectedCollectionCode) {
        //         that.$notify({
        //             text: "No entries found.",
        //             duration: 10000,
        //             type: "warn"
        //         });

        //         that.collectionCode = '';
        //         that.collectionCodeStatus = '';

        //         return;
        //     }

        //     that.collectionCodeStatus = that.selectedCollectionCode.status;
        //     that.collectionCode = that.selectedCollectionCode.collection_code;
        // },
        search: async function () {
            const that = this;

            that.startDate = '';
            that.endDate = '';
            that.selectedCollectionCode = null;
            that.collectionCode = '';
            that.collectionCodeStatus = '';

            if(!that.keyword.trim()) {
                return;
            }

            const response = await HTTP.get('/kenya/search-collection-codes/', {
                params: {
                    keyword: that.keyword
                }
            });

            if(response.data.length) {
                that.selectedCollectionCode = response.data[0];
            }

            if(!that.selectedCollectionCode) {
                that.$notify({
                    text: "No entries found.",
                    duration: 10000,
                    type: "warn"
                });

                return;
            }

            that.collectionCodeStatus = that.selectedCollectionCode.status;
            that.collectionCode = that.selectedCollectionCode.collection_code;
        },
        updateCollectionCodeStatus: function (status) {
            const that = this;
            HTTP.post("/kenya/update-collection-code-status/", {
                status: status,
                collection_code: that.selectedCollectionCode.collection_code,
            })
                .then(() => {
                    that.selectedCollectionCode.status = status;
                    that.collectionCodeStatus = status;
                })
                .catch((error) => {
                    if ("message" in error.response.data) {
                        this.$notify({
                            text: error.response.data.message,
                            duration: 10000,
                            type: "error",
                        });
                    }
                });
        },
        filter: function () {
            const that = this;

            that.endDate = '';
            that.keyword = '';
            that.collectionCode = '';
            that.collectionCodeStatus = '';
            that.selectedCollectionCode = null;
            
            // Trick to only search on endDate change.
            setTimeout(() => {
                that.startDate = that.formData.start_date;
                that.endDate = that.formData.end_date;
            }, 1000);
        },
        download: function () {
            const that = this;

            // Copied from ento data.
            let data = {
                collection_code: '',
                start_date: that.formData.start_date,
                end_date: that.formData.end_date,
                download: 1,
                download_type: 'anoph'
            };

            that.getEntoData(data).then(response => {
                var fileURL = window.URL.createObjectURL(
                    new Blob([response.data])
                );
                var fileLink = document.createElement("a");
                fileLink.href = fileURL;
                fileLink.setAttribute("download", "anopheles.csv");
                document.body.appendChild(fileLink);
                fileLink.click();
            });
        },
        unpackUrlQueryParams(query_obj){
            if ("collectionCode" in query_obj) {
                this.collectionCode, this.keyword = query_obj.collectionCode;
                this.search();
            }
        },
    },
    beforeRouteUpdate(to, from, next) {
        // Since we are re-using the view, when it is updated, set the current tab to the 'to' route tabIndex or set it to
        // zero.
        this.tabIndex = to.query.tabIndex ? parseInt(to.query.tabIndex) : 0;
        next();
    },
};
</script>

<style>
@import "~handsontable/dist/handsontable.full.css";

.ht {
    width: 100%;
}
.nav-tabs .nav-link {
    font-weight: 500;
    color: #999;
}
</style>
